import * as React from "react";
import { LocationList } from "components/templates";
import { Text } from "components/elementsThemed";
import { Loader, Empty } from "components/fragments";
import { images, Copy } from "utils";
import css from "./locationType2.module.scss";

const LocationSection = ({
  fetching,
  diningOption,
  locations,
  deliveryFetchCount,
  onLocationSelected,
  style: { labels, cells },
  locationCardRefs,
}) => {
  const getLocationSection = () => {
    if (fetching) {
      return (
        <div className={css["loader-container"]}>
          <Loader />
        </div>
      );
    }

    if (locations.length) {
      return (
        <LocationList
          datatest="location-list"
          diningOption={diningOption}
          locations={locations}
          type={cells.primary}
          refs={(id, ref) => {
            const locationCardRefsTemp = { ...locationCardRefs };
            locationCardRefsTemp.current[id] = ref;
          }}
          onClick={onLocationSelected}
        />
      );
    }

    if (diningOption === "delivery" && deliveryFetchCount.current) {
      return (
        <div className={css["delivery-no-results"]}>
          <Empty imgSrc={images?.art_empty_locations}>
            <div>
              <Text type={labels.secondary}>
                {Copy.LOCATIONS_STATIC.NO_LOCATIONS_TO_DELIVER_MESSAGE}
              </Text>
            </div>
            <div>
              <Text type={labels.secondary}>
                {Copy.LOCATIONS_STATIC.PICK_UP_SUGGESTION_MESSAGE}
              </Text>
            </div>
          </Empty>
        </div>
      );
    }

    if (diningOption === "delivery" && !deliveryFetchCount.current) {
      return (
        <div className={css["delivery-no-results"]}>
          <Empty imgSrc={images?.art_empty_locations}>
            <Text type={labels.secondary}>
              {Copy.LOCATIONS_STATIC.SEARCH_DELIVER_LOCATIONS_MESSAGE}
            </Text>
          </Empty>
        </div>
      );
    }
    return null;
  };

  return <>{getLocationSection()}</>;
};

export default LocationSection;
